<template>
    <div class="app-container">
      <BjRouteTabs :route-list="ORDER_ABNORMAL_FIVE_ROUTE_LIST" />
      <BjPage ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :radio="radio"
      :before-reset-search="beforeResetSearch"
      :tooltip-config="{ showAll: false, enterable: false }"
      :selection="selection"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
      @afterFetchOriginalData="getTableData"
      >
        <template v-slot:baseForm>
            <BjSelectChannelStore :span="colSpan" :query-params="queryParams" :query-props="['channel', 'storeIdList']" multiple />
            <el-col :span="colSpan">
              <el-form-item :label="$t('InternalOrder.No')" prop="orderNo">
                <BjInput v-model="queryParams.orderNo" :placeholder="$t('InternalOrder.No')" @keyup.enter.native="handleQuery" />
              </el-form-item>
            </el-col>
            <el-col :span="colSpan">
              <el-form-item :label="$t('InternalOrder.order')">
                <BjDateRangePicker v-model="queryParamsTime_order" :placeholder="$t('InternalOrder.order')" />
              </el-form-item>
            </el-col>
            <el-col v-if="!$store.getters.cusId" :span="colSpan">
              <el-form-item :label="$t('billingPage.CustomerName')" prop="cusId">
                <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" />
              </el-form-item>
            </el-col>
        </template>
        <!-- 展示列表 -->
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop !== 'bjTableAction'">
              <template slot-scope="scope">
                <template v-if="false" />
                <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(scope.row.cusId) }}</template>
                <template v-else-if="col.prop === 'outerOrderNo'">
                  <span>{{ scope.row.webReference }}</span>
                  <BjCopyIcon :copy="scope.row.webReference" />
                </template>
                <template v-else-if="col.prop === 'sapOrderNo'">
                  <span>{{ scope.row.sapOrderNo }}</span>
                  <BjCopyIcon :copy="scope.row.sapOrderNo" />
                </template>
                <template v-else-if="col.prop === 'tagsList'">
                  <BjTagList :tag-code-array="scope.row[col.prop]" size="mini" circle />
                </template>
                <template v-else-if="col.prop === 'failureReason'">
                  {{ $t(LANG_ZH_EN_PS_LIST.bjGet(scope.row[col.prop])) }}
                </template>
                <template v-else-if="col.prop === 'orderTime'">
                  <span>{{ scope.row[col.prop] | timeOptimization }}</span>
                </template>
                <template v-else-if="col.prop === 'creationDate'">
                  <span>{{ scope.row[col.prop] | timeOperateTwoHour }}</span>
                </template>
                <template v-else-if="col.prop === 'shippingMethod'">
                  <el-tag v-if="['CUSTOMER MANUAL', 'CSG MANUAL', 'PICKUP'].includes(scope.row[col.prop])" type="success">{{ scope.row[col.prop] }}</el-tag>
                  <span v-else>{{ scope.row[col.prop] }}</span>
                </template>
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template slot-scope="props">
                <el-button type="text" class="edit-btn" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
                <el-button :disabled="props.row.isMark" type="text" class="edit-btn" @click="onMark(props.row)">{{ $t('markText') }}</el-button>
                <el-button v-if="props.row.hjShipmentTime" type="text" class="delete-btn" @click="onCancel(props.row)">{{ $t('cancelText') }}</el-button>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
    </div>
  </template>
  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { orderApi } from '@/api';
  import { ORDER_ABNORMAL_FIVE_ROUTE_LIST,
    LANG_ZH_EN_PS_LIST,
    ORDER_INTERNAL_HAND_UP_STATUS_LIST,
  } from '@/utils/constants';
  export default {
    name: 'BusinessAbnormalOrderPendingHJCancel',
    components: {},
    mixins: [pageMiXin],
    data() {
      return {
        selection: true,
        colSpan: 4,
        ORDER_ABNORMAL_FIVE_ROUTE_LIST,
        LANG_ZH_EN_PS_LIST,
        ORDER_INTERNAL_HAND_UP_STATUS_LIST,
        queryApi: orderApi.getInternalPage,
        // 查询参数
        queryParamsTime_order: [],
        queryParams: {
          orderNo: null,
          orderStartTime: null,
          payEndTime: null,
          channel: null,
          storeIdList: [],
          cusId: null,

          hjOrderStatus: 4,
        },
        labelList1: [
          { label: this.$t('billingPage.CustomerName'), prop: 'cusId', isCheck: true, disabled: false, width: '100' },
          { label: this.$t('InternalOrder.form.number'), prop: 'outerOrderNo', isCheck: true, disabled: false, width: 145 },
          { label: this.$t('InternalOrder.form.wmsOrderNo'), prop: 'sapOrderNo', isCheck: true, disabled: false},
          { label: this.$t('InternalOrder.form.channel'), prop: 'channelTypeMeaning', isCheck: true, disabled: false},
          { label: this.$t('InternalOrder.form.Sales'), prop: 'storeName', isCheck: true, disabled: false},
          { label: this.$t('InternalOrder.form.orderStatusStr'), prop: 'orderStatusStr', isCheck: true, disabled: false },
          { label: this.$t('InternalOrder.form.Label'), prop: 'tagsList', isCheck: true, disabled: false, width: '80' },
          { label: this.$t('orderNewPatch.Shipping'), prop: 'shippingMethod', isCheck: true, disabled: false},
          { label: this.$t('orderNewPatch.Ordered'), prop: 'orderTime', isCheck: true, disabled: false },
          { label: this.$t('orderNewPatch.Created'), prop: 'creationDate', isCheck: true, disabled: false},
          { label: this.$t('InternalOrder.form.Product'), prop: 'goodsQuatity', isCheck: true, disabled: false, width: '90'},
          { label: this.$t('InternalOrder.form.document'), prop: 'trackingNumber', isCheck: true, disabled: false },
          { label: this.$t('orderNewPatch.ShippingCost'), prop: 'totalPrice', isCheck: true, disabled: false },
          { label: this.$t('orderNewPatch.Courier'), prop: 'logisticsCompany', isCheck: true, disabled: false },
          { label: this.$t('InternalOrderListcompent.name'), prop: 'receiverName', isCheck: true, disabled: false },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 180 },
        ],
      };
    },
    computed: {
      labelList() {
        return this.$store.getters.cusId ? this.labelList1.filter(item => item.prop != 'cusId') : this.labelList1;
      },
    },
    watch: {
      queryParamsTime_order(v) {
        this.queryParams.orderStartTime = (v || [])[0];
        this.queryParams.orderEndTime = (v || [])[1];
      },
    },
    mounted() {},
    methods: {
      // 获取页面数据
      getTableData(data) {
        data.content.forEach(e=>{
          if(e.tagsList){
            // isMark ==> 通过tagsList返回判断是否已 打标
            e.isMark = e.tagsList.includes('LB17248987386601908411220') ? true : false
          }else{
            e.isMark = false
          }
        });
      },
      // 查看
      onView(row) {
        // 内部订单详情页
        this.$router.push({
          name: 'BusinessOrderInternalViewCSG',
          query: { id: '', code: encodeURIComponent(row.innerOrderNo), type: 'edit', status: row.totalOrderStatus, orderHandleStatus: row.orderHandleStatus },
        });
      },
      // 打标
      onMark(row){
        const orderId = '';
        const orderCode = row.innerOrderNo;
        if(row.tagsList){
          const tagsList = row.tagsList.concat('LB17248987386601908411220').join(",");
          orderApi.getInternalDetailByIdCode({ orderCode, orderId}).then(e => { 
            orderApi.updateOrderBase({ orderId: e.orderInfoVO.id, tags: tagsList }).then(res => {
              if (!res.failed) {
                this.msgSuccess(this.$t('toast.operationSuccessText'));
              }
            });
          });
        }else{
          orderApi.getInternalDetailByIdCode({ orderCode, orderId}).then(e => { 
            orderApi.updateOrderBase({ orderId: e.orderInfoVO.id, tags: 'LB17248987386601908411220' }).then(res => {
              if (!res.failed) {
                this.msgSuccess(this.$t('toast.operationSuccessText'));
              }
            });
          });
        }
      },
      // 取消订单
      onCancel(item){
        this.$confirm(this.$t('InternalSalesOrderDetails.want'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
        .then(() => {
          orderApi.cancelInternalOrder({ innerOrderNo: item.innerOrderNo,isCancel:true }).then(res => {
            if (res.failed === false) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.reFresh();
              }, 500);
            }
          });
        })
      },
      /** 重置按钮操作 */
      beforeResetSearch() {
        this.queryParamsTime_order = null;
        this.queryParams.storeIdList = null;
        this.queryParams.cusId = null;
        return new Promise(resolve => {
          resolve();
        });
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  ::v-deep .bj-page .el-form-item__label{
    display: none;
  }
  </style>
